import { getAssetUrl } from '../helpers'
import './styles.css'

type Props = {
  onClick: () => void
  iconName: string
  disabled?: boolean
}

export default function RoundButton({ onClick, iconName, disabled }: Props) {
  return (
    <div className={`round-button-hitslop ${disabled ? ' disabled' : ''}`} onClick={onClick}>
      <div className="round-button">
        <img src={`${getAssetUrl(`${iconName}.svg`)}`} alt="Round Button to change info" />
      </div>
    </div>
  )
}
